import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

import variables from "../../constants/assets/variables";
import {
  NotesSection,
  UploadCsvOption,
} from "../../constants/assets/containers";
import FileUpload from "../Common/FileUpload";
import InformationBar from "../Common/InformationBar";
import * as UserActions from "../../store/actions/User";

const BulkUploadFile = ({
  instructions, //set of instructions or note
  sampleURL, //sample url of file to download
  keyName, //keyName of the key to be send in acknowledgement
  uploadUrl, //upoadUrl is the url on which the ack will be sent
  sendExtraAck, //pass boolean value if to pass filepath as extra param or not in ack call
  callback_key,
  presign_url,
  file_path,
  setUploadedFileName,
  setActiveFilePath,
  activeFile,
  setActiveFile,
  activeFileName,
  setActiveFileName,
  validationType,
}) => {
  const [sample_download_url, setSampleDownloadUrl] = useState("");

  useEffect(() => {
    const download_url = `${
      process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL.replace(
            variables.routeEndpoint,
            variables.sampleFileEndPoint
          )}${sampleURL}`
        : ""
    }`;

    if (sampleURL) {
      setSampleDownloadUrl(download_url);
    }
  }, []);

  const handleFileUploadSuccess = () => {
    if (activeFileName) {
      setUploadedFileName(activeFileName);
      console.log("Success");
    }
    setActiveFilePath(file_path);
  };

  const extraParamsAckObj = useMemo(() => {
    return sendExtraAck
      ? {
          file_path: file_path,
          presign_url: presign_url,
          filename: activeFileName,
          file_type: activeFile.type,
        }
      : {};
  }, [sendExtraAck, file_path, presign_url]);

  return (
    <section>
      <UploadCsvOption>
        <FileUpload
          title="CSV file"
          uploadUrl={uploadUrl}
          callback_key={callback_key}
          presign_url={presign_url}
          keyName={keyName || "callback_key"}
          activeFile={activeFile}
          setActiveFile={setActiveFile}
          extraParamsAckObj={extraParamsAckObj}
          acceptTypes={".csv, .xls, .xlsx"}
          handleFileUploadSuccess={handleFileUploadSuccess}
          activeFileName={activeFileName}
          setActiveFileName={setActiveFileName}
          validationType={validationType}
        />
      </UploadCsvOption>
      <NotesSection>
        <InformationBar
          sampleUrl={sample_download_url}
          instructions={instructions}
        />
      </NotesSection>
    </section>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setUploadedFileName: bindActionCreators(
      UserActions.setUploadedFileName,
      dispatch
    ),
    setActiveFilePath: bindActionCreators(
      UserActions.setActiveFilePath,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(BulkUploadFile);
